import { useContext } from "react";
import { ToastContext } from "../contexts/ToastContext";

export const useToast = () => {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }

  const showSuccess = (message: string) => {
    context.addToast(message, "success");
  };

  const showError = (message: string) => {
    context.addToast(message, "error");
  };

  const showInfo = (message: string) => {
    context.addToast(message, "info");
  };

  return {
    showSuccess,
    showError,
    showInfo,
    removeToast: context.removeToast,
  };
};

